import { useTranslation } from 'react-i18next';
import { Button, Icon } from 'ui';

type P = { count: number; isLiked: boolean; isLoading: boolean; onClickLike: () => void };

const LikeButton = ({ count, isLiked, isLoading, onClickLike }: P) => {
  const { t } = useTranslation();

  return (
    <Button
      danger={isLiked}
      icon={isLiked ? <Icon icon="heart-fill" /> : <Icon icon="heart-line" />}
      loading={isLoading}
      onClick={onClickLike}
      type="link-secondary"
    >
      {t('likesCount', { count })}
    </Button>
  );
};

export default LikeButton;
